module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/Integrations.ejs -->\n';
 if (provider === 'quickbooks') { 
__p+='\n    '+
((__t=( require('./integrations/quickbooks/Quickbooks.ejs')({model: model}) ))==null?'':__t)+
'\n';
 } else if (provider === 'xero') { 
__p+='\n    '+
((__t=( require('./integrations/xero/Xero.ejs')({
        model: model, contacts: contacts, mappingTypes: mappingTypes, organisations: organisations
    }) ))==null?'':__t)+
'\n';
 } else { 
__p+='\n    Missing template for provider: '+
((__t=( provider ))==null?'':_.escape(__t))+
'\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/Integrations.ejs
// module id = 872
// module chunks = 1